import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const HanaPayment = () => {
  return <CommonProcess />;
};

export default HanaPayment;
